// extracted by mini-css-extract-plugin
var _1 = "borderRadius -e5gp";
var _2 = "#007ac9";
var _3 = "button-aDXn";
var _4 = "#575757";
var _5 = "disabled-hweo";
var _6 = "disabledClickable-LcLL";
var _7 = "1.5rem";
var _8 = "hasNoMargin-Yon6";
var _9 = "hasPadding-OrUu";
var _a = "#dedede";
var _b = "#adf";
var _c = "1rem";
var _d = "#bebebe";
var _e = "reverseColor-FV0l";
var _f = "round-TYOe";
var _10 = ".8rem";
var _11 = "transition-_2mB";
var _12 = "#000";
var _13 = "wide-Ujsd";
export { _1 as "borderRadius", _2 as "busBlue", _3 as "button", _4 as "darkGrey", _5 as "disabled", _6 as "disabledClickable", _7 as "extraLargeFontSize", _8 as "hasNoMargin", _9 as "hasPadding", _a as "lightGrey", _b as "lightblue", _c as "mediumFontSize", _d as "mediumLightGrey", _e as "reverseColor", _f as "round", _10 as "smallFontSize", _11 as "transition", _12 as "unusedNodeColor", _13 as "wide" }
